import React, { Component } from "react";
import { connect } from "react-redux";
import { Collapse } from "reactstrap";
import classNames from "classnames";
import { docPermConstants } from "../../../_constants/permissionConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AlertModal from "../../_common/AlertModal";

class AdminContractorDetails extends Component {
  state = {
    projList: [],
    showAlert_deleteContractorConfirm: false,
  };

  componentDidMount() {
    const { contractor } = this.props;
    if (contractor) {
      this.setState({
        projList: (contractor.projects || []).map((p) => ({ ...p, isExpanded: false })),
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { contractor, contractorId } = this.props;
    // Reset this.state.projList if:
    // 1) Previously no contractor was selected, but one is selected now
    // 2) Previously a contractor was selected, and a different contractor
    //    is selected now
    if (contractor && prevProps.contractor !== contractor) {
      this.setState({
        projList: (contractor.projects || []).map((p) => ({ ...p, isExpanded: false })),
      });
    }
  }

  handleClick_expandContractorProjRow = (rowIndex) => (e) => {
    e.preventDefault();
    const projList = this.state.projList.map((p) => ({ ...p }));
    projList[rowIndex].isExpanded = !projList[rowIndex].isExpanded;
    this.setState({ projList });
  };

  handleClick_deleteContractor = (e) => {
    e.preventDefault();
    this.toggleAlert_deleteContractorConfirm();
  };

  toggleAlert_deleteContractorConfirm = () =>
    this.setState({
      showAlert_deleteContractorConfirm: !this.state.showAlert_deleteContractorConfirm,
    });

  handleAlert_deleteContractorConfirm = (action) => () => {
    this.toggleAlert_deleteContractorConfirm();
    if (action === "accept") {
      const { contractor, deleteContractor } = this.props;
      deleteContractor(contractor);
    }
  };

  renderContractorProjectRow = (project, index) => (
    <div
      key={`cpRowKey_${index}`}
      className={classNames("list-group-item py-1 pl-1", {
        "custom-table-selected":
          this.state.projList[index] && this.state.projList[index].isExpanded,
      })}
    >
      <div
        className="d-flex flex-row w-100 align-middle pointer-cursor"
        onClick={this.handleClick_expandContractorProjRow(index)}
      >
        <div className="px-1" style={{ width: "10%" }}>
          <FontAwesomeIcon
            icon={
              this.state.projList[index] && this.state.projList[index].isExpanded
                ? "caret-up"
                : "caret-down"
            }
            className="fa-fw"
          />
        </div>
        <div className="pr-1" style={{ width: "30%" }}>
          <span
            className={classNames({
              "text-strong":
                this.state.projList[index] && this.state.projList[index].isExpanded,
            })}
          >
            {project.fullEA}
          </span>
        </div>
        <div className="px-1" style={{ width: "40%" }}>
          <span>{project.coRtePm}</span>
        </div>
        <div className="pl-1" style={{ width: "20%" }}>
          <span>{project.isPrime ? "Prime" : "Sub"}</span>
        </div>
      </div>
      <Collapse
        isOpen={this.state.projList[index] && this.state.projList[index].isExpanded}
      >
        <div className="card mt-1">
          <div className="card-body p-2">
            <div className="row">
              <div className="col-md-12">
                <b>Proj. Work Description:</b>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">{project.workDescription}</div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <b>Contact: </b>
              </div>
              <div className="col-md-9">
                {`${project.contactFullName || "(N/A)"}${
                  project.contactTitle ? ", " + project.contactTitle : ""
                }`}
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <b>Phone: </b>
              </div>
              <div className="col-md-9">{project.phone || "(N/A)"}</div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <b>Address: </b>
              </div>
              <div className="col-md-9">{project.address || "(N/A)"}</div>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );

  render() {
    const { projList, showAlert_deleteContractorConfirm } = this.state;
    const { contractor, handleClick_edit, permissions, fetching } = this.props;
    return (
      <React.Fragment>
        {contractor ? (
          <h3 className="card-title mx-0">{contractor.name}</h3>
        ) : fetching ? (
          <h5 className="text-muted">
            <FontAwesomeIcon icon="spinner" className="fa-fw mr-2" spin />
            Loading...
          </h5>
        ) : (
          <h5 className="text-muted">Select a contractor to view details</h5>
        )}
        {contractor && (
          <React.Fragment>
            <div className="row mx-0 pl-0">
              <div className="col pl-0">
                <ul className="list-group-flush border-bottom border-top mb-2 pl-0">
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Name:</b>
                      </div>
                      <div className="col pl-1">{contractor.name}</div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Abbreviation:</b>
                      </div>
                      <div className="col pl-1">
                        {contractor.abbreviation || "(No abbrev. provided)"}
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Is Joint Venture:</b>
                      </div>
                      <div className="col pl-1">
                        {contractor.isJointVenture ? "Yes" : "No"}
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Labor Count (Verified):</b>
                      </div>
                      <div className="col pl-1">{contractor.laborCount}</div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Equipment:</b>
                      </div>
                      <div className="col pl-1">{contractor.equipmentCount}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <h5 className="text-muted mx-0 mt-1">Projects (Past/Ongoing)</h5>
            <div className="list-group-flush mx-0 pl-0 mb-0">
              <div className="list-group-item py-1 pl-1 bg-lightgray">
                <div className="d-flex flex-row w-100">
                  <div className="pr-1" style={{ width: "10%" }}></div>
                  <div className="px-1" style={{ width: "30%" }}>
                    <b>EA</b>
                  </div>
                  <div className="px-1" style={{ width: "40%" }}>
                    <b>PM</b>
                  </div>
                  <div className="pl-1" style={{ width: "20%" }}>
                    <b>Role</b>
                  </div>
                </div>
              </div>
            </div>
            <div className="contractor-details-projects border">
              <div className="list-group-flush pl-0 mb-0">
                {projList.length > 0 ? (
                  projList.map((p, index) => this.renderContractorProjectRow(p, index))
                ) : (
                  <li className="list-group-item py-1 pl-1">
                    No projects for this contractor
                  </li>
                )}
              </div>
            </div>
            <hr className="my-2" />
            <div className="form-row form-group ml-1">
              <button
                type="button"
                name="editContractor"
                id="editContractor"
                className="btn btn-secondary mr-2"
                onClick={handleClick_edit}
                disabled={!permissions.includes(docPermConstants.EDIT_LEVEL_2)}
              >
                Edit...
              </button>
              <button
                type="button"
                name="deleteContractor"
                id="deleteContractor"
                className="btn btn-danger"
                onClick={this.handleClick_deleteContractor}
                disabled={!permissions.includes(docPermConstants.EDIT_LEVEL_2)}
              >
                Delete
              </button>
            </div>
          </React.Fragment>
        )}
        {showAlert_deleteContractorConfirm && (
          <AlertModal
            alertTitle="Confirm Delete"
            alertTitleClass="bg-danger text-white"
            alertTitleIcon="exclamation-triangle"
            alertText="Are you sure you want to delete this contractor?"
            acceptCaption="Yes"
            acceptClass="danger"
            provideReject={true}
            rejectCaption="No"
            rejectClass="secondary"
            handleAlertAction={this.handleAlert_deleteContractorConfirm}
            showAlertModal={showAlert_deleteContractorConfirm}
            toggleAlertModal={this.toggleAlert_deleteContractorConfirm}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  fetching: state.contractors.fetching,
  contractor: state.contractors.openContractorDetails[ownProps.contractorId] || null,
});

export default connect(mapStateToProps)(AdminContractorDetails);
